module.exports = __webpack_public_path__ + "img/296669073757891278.5ecf34c5.png";